<div class="card" tabindex="-1" (click)="clickCard()">
  <div class="container">
    <div class="card-title">盐城高测智慧能源平台</div>
    <div class="logo">
      <img src="assets/img/logo.png"  />
    </div>
    <div class="recent-user">
      <div class="recent-use-text">最近使用</div>
      <div class="name-group">
        <div *ngFor="let item of Users; let i = index">
          <div [style]="'background:#' +bgColors[i] +';color:#'+ fontColors[i]+';border:1px solid #'+ fontColors[i]"
            class="name" nz-tooltip [nzTooltipTitle]="toolTip" nzTooltipPlacement="bottomLeft">
            {{ item.abbreviatedName }}
          </div>
          <ng-template #toolTip>
            <div class="tooTip-content">
              <div class="visitor-name">{{item.fullName}}</div>
              <div class="visitor-position">{{item.position}}</div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div class="divider"></div>
  <div class="footer">
    <div class="last-visit-text">上次访问：</div>
    <div class="last-visit-line" *ngIf="Users && Users.length>0">
      <div class="time">{{ Users[0].visitTime | date:'yyyy/MM/dd HH:mm:ss' }}</div>
      <div class="full-name">{{ Users[0].fullName }}</div>
    </div>
  </div>
</div>